function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M74.454 38.903V3.853l35.052 35.05z",
    style: {
      fill: "#fed0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.284 3.852h54.447v34.775h34.775v86.312H20.284z",
    style: {
      fill: "#ff9348"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.378 55.908 62.483 84.94 45.89 68.27l-7.116 7.16 15.039 15.113 7.75 7.788.92.92 36.01-36.192-7.116-7.16z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgIcon;